export default {
      id: "smtp_settings-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "img/icons.svg#smtp_settings",
      toString: function () {
        return this.url;
      }
    }